import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'

import useStyles from './styles'

const BackButton = (props) => {
  const classes = useStyles()
  const history = useHistory()

  const redirect = () => history.goBack()

  return (
    <Button
      type="button"
      variant="outlined"
      className={classes.backButton}
      onClick={redirect}
      {...props}
    >
      Voltar
    </Button>
  )
}

export default BackButton
